import { useEffect } from "react";

import { Text } from "@design-system/Text/Text";

import classes from "./EnvironmentBanner.module.css";

export const EnvironmentBanner = () => {
  const isStaging =
    import.meta.env.MODE === "stage" ||
    import.meta.env.VITE_ENVIRONMENT === "stage" ||
    window.location.hostname.includes("stage");

  useEffect(() => {
    if (isStaging) {
      document.documentElement.style.setProperty(
        "--addon-banner-height",
        "30px",
      );
    }
  }, [isStaging]);

  if (!isStaging) {
    return null;
  }

  const bannerText =
    "You are viewing the staging environment - this is not production";

  return (
    <div className={classes.banner}>
      <Text color="white" weight={500} size={12}>
        {bannerText}
      </Text>
    </div>
  );
};
